<section>
  <div class="row">
    <!-- value -->
    <div class="sm:tw-w-1/4">
      <form-field
        [(value)]="model"
        [control]="form?.get('value')"
        label="common.value"
        classList="dir-ltr"
        class="tw-w-full"
        (change)="emitOption()"
      >
      </form-field>
    </div>

    <div class="md:tw-w-1/12 tw-flex-start">
      <!-- remove btn -->
      @if(showDeleteOptionBtn){
      <button
        [matTooltip]="'common.delete' | translate"
        class="mat-ripple tw-flex-center btn tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise btn-danger tw-rounded-full tw-w-12 tw-h-12"
        (click)="onRemoveOption(index)"
      >
        <i class="mdi mdi-delete-outline mdi-20px"></i>
      </button>
      }

      <!-- add btn -->
      @if(showAddOptionBtn){
      <button
        [matTooltip]="'common.add' | translate"
        class="mat-ripple tw-flex-center btn tw-mr-[5px] ltr:tw-ml-[5px] button-shadow btn-hover-rise btn-blue tw-rounded-full tw-w-12 tw-h-12"
        (click)="emitAddOption()"
      >
        <i class="mdi mdi-plus mdi-20px"></i>
      </button>
      }
    </div>
  </div>
</section>
